<template>
  <div class="case-detail">
    <el-card class="box-card pad">
      <span class="clearfix-sapn">基本资料</span>
      <div class="p_bd">
        <div class="info-box">
          <div class="column">
            <span class="item">
              <span class="title">姓名：</span>
              <span class="txt">{{ patient.patientName }}</span>
            </span>
            <span class="item">
              <span class="title">年龄：</span>
              <span class="txt">{{ patient.patientAge }}</span>
            </span>
            <span class="item">
              <span class="title">性别：</span>
              <span class="txt">{{
                PATIENT_GENDER[patient.patientGender]
              }}</span>
            </span>
          </div>
        </div>
      </div>
      <span class="clearfix-sapn">主诉</span>
      <div class="p_bd">
        {{ cases.described || "无" }}
      </div>
      <span class="clearfix-sapn">现病史</span>
      <div class="p_bd">
        {{ cases.hip || "无" }}
      </div>
      <span class="clearfix-sapn">既往史</span>
      <div class="p_bd">
        {{ cases.patientHistory || "无" }}
      </div>
      <span class="clearfix-sapn">个人史</span>
      <div class="p_bd">
        {{ cases.personalHistory || "无" }}
      </div>
      <span class="clearfix-sapn">家族史</span>
      <div class="p_bd">
        {{ cases.familyHistory || "无" }}
      </div>
      <span class="clearfix-sapn">过敏史</span>
      <div class="p_bd">
        {{ cases.allergyHistory || "无" }}
      </div>
      <span class="clearfix-sapn">用药史</span>
      <div class="p_bd">
        {{ cases.drugHistory || "无" }}
      </div>
      <span class="clearfix-sapn">手术史</span>
      <div class="p_bd">
        {{ cases.operationHistory || "无" }}
      </div>
      <span class="clearfix-sapn">其他</span>
      <div class="p_bd">
        {{ cases.other || "无" }}
      </div>
      <span class="clearfix-sapn">病史小结</span>
      <div class="p_bd">
        {{ cases.patientRes || "无" }}
      </div>
      <span class="clearfix-sapn">诊断结果</span>
      <div class="p_bd">
        {{ cases.treatmentResName || "无" }}
      </div>
      <span class="clearfix-sapn">附件</span>
      <div class="img-list" v-if="imgList.length">
        <div v-for="(item, index) in imgList" :key="index">
          <el-image class="image" :src="item" :preview-src-list="imgList">
          </el-image>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { caseQueryById } from "@/api/index.js";
import { PATIENT_GENDER } from "@/utils/constants";

export default {
  data() {
    return {
      PATIENT_GENDER,
      imgList: [],
      patient: {
        id: "",
        gmtCreate: "",
        gmtModified: "",
        isDelete: 0,
        remark: null,
        patientName: "",
        memberId: "",
        patientGender: 0,
        patientRelation: 0,
        patientMarital: 0,
        patientCardType: 0,
        patientCardNo: "",
        patientBirthdate: "",
        patientAge: 0,
        patientMobile: null,
        patientHistory: null,
        drugHistory: null,
        operationHistory: null,
        allergyHistory: null,
      },
      cases: {
        orderNo: "",
        gmtCreate: "",
        gmtModified: "",
        isDelete: 0,
        remark: null,
        departmentId: "",
        hospitalId: "",
        patientId: "",
        described: "",
        isSendDescribed: 0,
        symptom: null,
        report: null,
        hip: "",
        personalHistory: "",
        patientHistory: "",
        drugHistory: "",
        operationHistory: "",
        allergyHistory: "",
        patientRes: "",
        treatmentRes: "",
        diseaseId: null,
        treatmentResName: "",
        caseNumber: null,
        familyHistory: "",
        other: "",
      },
    };
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    //获取病例详情
    async getUserInfo() {
      const params = {
        orderNo: this.$route.query.orderNo,
      };
      const res = await caseQueryById(params);
      if (res.code == 1) {
        this.patient = res.data.patient;
        this.cases = res.data.cases;
        // 附件
        let casesSymptom = this.cases.symptom || false;
        if (casesSymptom)
          this.imgList =
            casesSymptom.indexOf(",") != -1
              ? casesSymptom.split(",")
              : [casesSymptom];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-card__body {
  margin: 20px 0 0 10px !important;
}

.case-detail {
  // padding-top: 20upx;
  // min-height: 700px;
  .el-card__body {
    padding: 20px;
  }

  .box-card {
    min-height: 190px;
  }
  .pad {
    margin-top: 20px;
  }
  .attachment {
    width: 100%;
  }
  .p_bd {
    line-height: 25px;
    color: #101010;
    margin: 30px 0;
    .el-input {
      margin: 8px 0;
    }
    .el-button {
      margin-top: 8px;
    }
    .title {
      margin-right: 10px;
    }
    .info-box {
      .column {
        .item {
          width: 20%;
          display: inline-block;
        }
      }
      .el-collapse {
        margin-top: 20px;
      }
    }
  }
  .img-list {
    display: flex;
  }
  .image {
    margin-top: 20px;
    width: 150px;
    height: 150px;
    margin-left: 30px;
    margin-bottom: 20px;
  }
  .clearfix-sapn {
    border-left: 5px solid #fc701a;
    padding-left: 5px;
    // color: #8e99ca;
  }
}
</style>
